import RmnMidPageBanner from 'components/Rmn/RmnMidPageBanner/RmnMidPageBanner';
import { withRmnMidPageBannerProps } from 'viewModel/rmn/rmnMidPageBanner/withRmnMidPageBannerProps';

const ConnectedRmnMidPageBanner = withRmnMidPageBannerProps(RmnMidPageBanner);

export default ConnectedRmnMidPageBanner;
